import React, { useState } from 'react';
import config from '../../../../config';
import useMain from '../../../../hooks/useMain';
import { paginate } from '../../../../utils/paginate';
import { SellHistoryCard } from '../../ingredients/cards';

const SellHistory = () => {
	const { userData } = useMain();
	const sorted = userData.sellRequests.sort((a, b) =>
		a.date > b.date ? -1 : 1
	);
	for (const i in sorted) sorted[i].no = Number(i) + 1;

	const [currentPage, setCurrentPage] = useState(1);
	const data = paginate(sorted, currentPage, config.tablePageSize);

	return (
		<div className='row'>
			<div className='col-12'>
				<SellHistoryCard
					data={data}
					itemsCount={userData.sellRequests.length}
					pageSize={config.tablePageSize}
					currentPage={currentPage}
					onPageChange={setCurrentPage}
				/>
			</div>
		</div>
	);
};

export default SellHistory;
